// extracted by mini-css-extract-plugin
module.exports = {"wrap":"sendMessagePage_wrap__veNQZ"};